export default __webpack_public_path__ + "static/Principle-harmony-362559e8551fbe73b3e910dd8ac744bc.png";